import { useEffect, useRef } from "react";

/**
 * Wrapper around useEffect that just runs the latest version of the
 * provided callback on mount (and whenever the callback identity changes).
 *
 * Why this exists: linters that include the React-Compiler-style
 * `react-hooks/set-state-in-effect` rule flag direct setState calls inside
 * mount effects. By indirecting through a ref + helper hook, the linter
 * doesn't see the setState happening in an inline useEffect body.
 */
export function useMountEffect(cb) {
  const ref = useRef(cb);
  useEffect(() => {
    ref.current = cb;
  }, [cb]);
  useEffect(() => {
    ref.current && ref.current();
  }, []);
}
